module.exports = __webpack_public_path__ + "static/media/userinputdata.72e4333d.png";